/* ****************************
指定されたURLの配列を読み込んだら $.Deferred を返す
***********************************/
/*

import preload from './preload';

var urls = ['image1.jpg', 'image2.jpg', 'image3.jpg'];

preload(urls,{
    onProgress (url, total, count, percent) {
        console.log("{progress}", url, total, count, percent);
    }
})
.fail((url, jqXHR, textStatus, errorThrown) => {
    console.log("{error}", url);
}).done((total, count) => {
    console.log("{comp}", total, count);
});
*/

export default function (list, config) {

    const defaults = {
        onProgress(url, total, count, percent) { }
    };
    const opt = Object.assign(defaults, config);

    // Deferred オブジェクト
    const defer = $.Deferred();
    const total = list.length;
    let count = 0;

    // 個々のURLを取得し、deferredオブジェクトを返す
    const promise = list.map(function (url) {
        return jQuery.get(url)
            .fail((jqXHR, textStatus, errorThrown) => {
                defer.rejectWith(
                    this, [url, jqXHR, textStatus, errorThrown]
                );
            })
            .done((e) => {
                const percent = (count + 1) / total;
                if (opt.onProgress) {
                    opt.onProgress(url, total, count, percent);
                }
                count += 1;
            });
    });

    // 全部読み込み終わったら実行
    jQuery.when.apply(null, promise)
        .done(() => {
            defer.resolve(total, count);
        });

    // promiseオブジェクトを返して fail()、done()、always()を使えるようにする
    return defer.promise();
}



// WEBPACK FOOTER //
// /Users/dada/www/_caracol_works/javascript/for_webpack/caracol/caracol_es2015.1.0/util/preload.js